module.exports = "/packs/images/svg/accessibility/accessible_changing~b06b4fa295752fba98c2d04561b7c1dc.svg";